export default {
  stripeKey: 'pk_live_v4hsF1UxfEHyEo6kUphYvxUU',
  apiUrl: 'https://api.donapp.it/v1/'
  // apiUrl: 'http://localhost:8080/v1/'
}



// WEBPACK FOOTER //
// ./src/config/constants.js